import React, { Component, Fragment } from 'react';
import {
  CloseCircleFilled,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Select, Input, Popover, Tooltip } from "antd";
import { strDelimited } from '../../../../services/helper/split';
import _ from 'lodash';
import { IMPEDANCE_PACKAGE_FILE } from '../../../../services/Cascade/constants';
import { getArraySimilar, splitArrayToArrays } from '../../../../services/helper/arrayHelper';

class pkgModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portList: [],
      maxHeight: 300
    }
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initData()
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { selectFileList, pairs } = this.props;
    if (!_.isEqual(selectFileList, prevProps.selectFileList)) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : '',
          notes: fileInfo ? fileInfo.notes : '',
        }
      })
    }
    if (pairs.length !== prevProps.pairs.length) {
      this.initPortList()
    }
  }


  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('spice-node-select-Popover')[0];
    const selectRoot = document.getElementsByClassName('nodes-list-file-dropdown')[0];

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || (PopoverRoot && !PopoverRoot.contains(target) && (!selectRoot || !selectRoot.contains(target)))) {
      this.closeNodesSelection();
    }
  }

  initData = () => {
    const { selectFileList } = this.props
    if (selectFileList.length) {
      const fileInfo = selectFileList[0]
      this.setState({
        selectFile: {
          libraryId: fileInfo ? fileInfo.libraryId : '',
          fileName: fileInfo ? fileInfo.fileName : '',
          modelKey: fileInfo ? fileInfo.modelKey : '',
          subckt: fileInfo ? fileInfo.subckt : '',
          nodes: fileInfo ? fileInfo.nodes : [],
          type: fileInfo ? fileInfo.type : '',
          notes: fileInfo ? fileInfo.notes : []
        }
      })
    }
    this.initPortList()
  }

  initPortList = () => {
    const { pairs } = this.props
    this.setState({
      portList: [...pairs]
    })
  }

  getDieNodes = (diePorts, net) => {
    if (diePorts.length) {
      const diePort = diePorts[0]
      return {
        ...diePort,
        port: `die_${net}`,
        nodes: diePorts.map(item => item.portName),
        isDie: true,
        powerNet: net
      }
    }
    return {
      port: `die_${net}`,
      nodes: [],
      designId: IMPEDANCE_PACKAGE_FILE,
      isDie: true,
      powerNet: net
    }
  }

  closeNodesSelection = () => {
    this.setState({
      editNode: null,
      editType: null,
      searchValue: null,
      editComp: null
    })
  }

  selectNodesFile = (keyObj) => {
    const { selectFileList } = this.props;
    if (!keyObj) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const [libraryId, modelKey, subckt] = strDelimited(keyObj.key, "::");
    if (!libraryId || !modelKey) {
      this.setState({
        selectFile: {}
      })
      return;
    }
    const fileInfo = selectFileList.find(item => item.libraryId === libraryId);
    this.setState({
      selectFile: {
        libraryId,
        fileName: fileInfo ? fileInfo.fileName : '',
        modelKey,
        subckt,
        nodes: fileInfo ? fileInfo.nodes : [],
        type: fileInfo ? fileInfo.type : '',
        notes: fileInfo ? fileInfo.notes : []
      }
    })
  }

  openSelectNode = ({ e, port, value, currentItem }) => {
    const { selectFile } = this.state
    const { selectFileList } = this.props
    const editDesignId = currentItem.designId
    const editPort = port
    const editPowerNet = currentItem.powerNet
    const editNode = `${editDesignId}-${editPowerNet}-${editPort}`
    const libraryId = currentItem.libraryId || ""
    const modelKey = currentItem.modelKey || ""
    const subckt = currentItem.subckt || ""
    let _selectFile = selectFile || {}
    if (libraryId) {
      const file = selectFileList.find(item => item.libraryId === libraryId && item.modelKey === modelKey)
      _selectFile = {
        libraryId,
        fileName: file ? file.fileName : "",
        subckt,
        modelKey,
        type: file ? file.type : "",
        nodes: file ? file.nodes : [],
        notes: file ? file.notes : []
      };
    }
    let top = 300;
    if (e && e.target) {
      const rect = e.target.getBoundingClientRect();
      top = rect ? rect.top || 300 : 300;
    }
    this.setState({
      editNode,
      searchValue: value && value.length ? value[0] : '',
      selectFile: _selectFile,
      maxHeight: top - 30 > 300 ? top - 30 : 300
    })
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }

  selectPinNode = ({ node, selectFile, currentItem, isDie }) => {
    if (currentItem && currentItem.port.includes('die') && isDie && currentItem.designId === IMPEDANCE_PACKAGE_FILE) {
      this.selectDieNode({ node, selectFile, currentItem });
      return
    }
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const subckt = selectFile.subckt, libraryId = selectFile.libraryId, modelKey = selectFile.modelKey, fileName = selectFile.fileName
    const index = _portList.findIndex(item => {
      return item.designId === currentItem.designId && item.port === currentItem.port && item.powerNet === currentItem.powerNet
    })
    if (index > -1) {
      if (_portList[index].nodes.includes(node)) {
        _portList[index].nodes = _portList[index].nodes.filter(n => n !== node)
      } else {
        _portList[index].nodes.push(node)
      }
      _portList[index].fileName = fileName
      _portList[index].libraryId = libraryId
      _portList[index].modelKey = modelKey
      _portList[index].subckt = subckt ? subckt : ""
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet)
    if (pairIndex > -1) {
      if (_pairs[pairIndex].nodes.includes(node)) {
        _pairs[pairIndex].nodes = _pairs[pairIndex].nodes.filter(n => n !== node)
      } else {
        _pairs[pairIndex].nodes.push(node)
      }
      _pairs[pairIndex].subckt = subckt ? subckt : ""
      _pairs[pairIndex].libraryId = libraryId
      _pairs[pairIndex].modelKey = modelKey
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  deleteSelectNode = (e, type, currentItem) => {
    e && e.stopPropagation()
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const index = _portList.findIndex(item => {
      return item.designId === currentItem.designId && item.port === currentItem.port && item.powerNet === currentItem.powerNet
    })
    if (index > -1) {
      _portList[index].nodes = []
      _portList[index].fileName = ""
      _portList[index].libraryId = ""
      _portList[index].modelKey = ""
      _portList[index].subckt = ""
    }
    const pairIndex = _pairs.findIndex(item => item.port === currentItem.port && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet)
    if (pairIndex > -1) {
      _pairs[pairIndex].nodes = []
      _pairs[pairIndex].subckt = ""
      _pairs[pairIndex].libraryId = ""
      _pairs[pairIndex].modelKey = ""
    }
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  selectDieNode = ({ node, selectFile, currentItem }) => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    const subckt = selectFile.subckt, libraryId = selectFile.libraryId, modelKey = selectFile.modelKey, fileName = selectFile.fileName
    const index = _portList.findIndex(item => {
      return item.designId === currentItem.designId && node === currentItem.portName && item.powerNet === currentItem.powerNet
    })
    if (index > -1) {
      _portList.splice(index, 1)
    } else {
      _portList.push({ designId: IMPEDANCE_PACKAGE_FILE, libraryId: libraryId || "", modelKey: modelKey || "", nodes: [], port: node, portName: node, powerNet: currentItem.powerNet, subckt: subckt || "", type: "right", fileName: fileName || "" })
    }
    const { trueArray: truePorts, falseArray: falsePorts } = splitArrayToArrays({ array: _portList, rule: (item) => item.designId === currentItem.designId && item.powerNet === currentItem.powerNet && item.type === "right" });
    _portList = [...falsePorts, ...truePorts.map((port, index) => ({ ...port, port: String(index + 1) }))]
    const pairIndex = _pairs.findIndex(item => item.portName === node && item.designId === currentItem.designId && item.powerNet === currentItem.powerNet)
    if (pairIndex > -1) {
      _pairs.splice(pairIndex, 1)
    } else {
      _pairs.push({ designId: IMPEDANCE_PACKAGE_FILE, libraryId: libraryId || "", modelKey: modelKey || "", nodes: [], port: node, portName: node, powerNet: currentItem.powerNet, subckt: subckt || "", type: "right", fileName: fileName || "" })
    }
    const { trueArray: truePairs, falseArray: falsePairs } = splitArrayToArrays({ array: _pairs, rule: (item) => item.designId === currentItem.designId && item.powerNet === currentItem.powerNet && item.type === "right" });
    _pairs = [...falsePairs, ...truePairs.map((port, index) => ({ ...port, port: String(index + 1) }))]
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  isSameNode = (port, selectFile, node) => {
    return (
      port.libraryId === selectFile.libraryId &&
      port.subckt === selectFile.subckt &&
      port.modelKey === selectFile.modelKey &&
      port.nodes.includes(node)
    );
  }

  getDisplayPortList = ({ currentItem, searchValue, selectFile }) => {
    const { portList } = this.state;
    const { nodes = [], notes = [] } = selectFile;
    const pcbItems = portList.filter(item => item.type === 'left');
    const diePorts = portList.filter(item => item.type === 'right');
    const nets = [...new Set(portList.map(port => port.powerNet))];
    const dieItems = nets.map(net => this.getDieNodes(diePorts.filter(item => item.powerNet === net), net));
    const nodeList = nodes.map(node => {
      let select = false;
      let currentSelect = false;
      if (this.isSameNode(currentItem, selectFile, node)) {
        currentSelect = true;
      }
      select = [...pcbItems, ...dieItems].some(item =>
        (item && (item.designId !== currentItem.designId || item.powerNet !== currentItem.powerNet || item.port !== currentItem.port) && this.isSameNode(item, selectFile, node))
      );
      const notePort = notes.find(item => item.port === node);
      let note = notePort ? notePort.info : node
      return { node, select, currentSelect, note };
    });

    const current = nodeList.filter(item => item.currentSelect);
    const matched = nodeList.filter(item => item.node.includes(searchValue) && !item.currentSelect && !item.select);
    const unused = nodeList.filter(item => !item.select && !item.currentSelect && !item.node.includes(searchValue));
    const used = nodeList.filter(item => item.select && !item.currentSelect);

    return [...current, ...matched, ...unused, ...used];
  }

  searchNode = (e) => {
    this.setState({
      searchValue: e.target.value
    })
  }

  cleanPort = () => {
    const { portList } = this.state
    const { pairs } = this.props
    let _portList = JSON.parse(JSON.stringify(portList))
    let _pairs = JSON.parse(JSON.stringify(pairs))
    _portList = _portList.filter(item => item.type !== 'right').map(item => {
      return {
        ...item,
        nodes: [],
        subckt: "",
        libraryId: "",
        modelKey: "",
        fileName: ""
      }
    })
    _pairs = _pairs.filter(item => item.type !== 'right').map(item => {
      return {
        ...item,
        nodes: [],
        subckt: "",
        libraryId: "",
        modelKey: "",
        fileName: ""
      }
    })
    this.props.updatePairs(_pairs)
    this.setState({
      portList: _portList
    })
  }

  autoSetPorts = (fileInfo) => {
    const { portList } = this.state
    const { pairs } = this.props
    const { subckt, nodes, libraryId, fileName, modelKey, notes = [] } = fileInfo;
    let _portList = portList.filter(item => item.type === 'left');
    let _pairs = pairs.filter(item => item.type === 'left');

    let nodeInfos = notes.length ? notes : nodes.map(item => ({ node: item, info: item }));
    let nodeBGA = nodeInfos.filter(item => item.info.match(/(VDD|BGA)/ig));
    let nodeBump = nodeInfos.filter(item => item.info.match(/(VSS|BUMP)/ig) && !nodeBGA.some(i => i.info === item.info))

    if (!nodeBGA.length) {
      const nodeDIE = nodeInfos.filter(item => item.info.match(/(DIE)/ig) && !nodeBump.some(i => i.info === item.info))
      if (nodeDIE.length) {
        nodeBGA = nodeInfos.filter(item => item.info.match(/(VSS|BUMP)/ig))
        nodeBump = [...nodeDIE]
      }
    }

    const powerNets = _portList.map(port => port.powerNet);
    const rightPorts = nodeBump.map((node) => {
      const port = powerNets.map(_net => ({ net: _net, similar: getArraySimilar((node.node || node.port).toLowerCase(), _net.toLowerCase()) })).sort((a, b) => b.similar - a.similar)
      const net = port && port.length ? port[0].net : powerNets[0] ? powerNets[0] : 'powerNet';
      return {
        port: node.node || node.port,
        portName: node.node || node.port,
        powerNet: net,
        designId: IMPEDANCE_PACKAGE_FILE,
        nodes: [],
        subckt: subckt || "",
        libraryId: libraryId,
        modelKey: modelKey,
        fileName: fileName,
        type: 'right'
      }
    });
    let _rightPorts = [];
    for (let powerNet of powerNets) {
      const { trueArray: truePairs } = splitArrayToArrays({ array: rightPorts, rule: (item) => item.powerNet === powerNet && item.type === "right" });
      _rightPorts.push(...truePairs.map((port, index) => ({ ...port, port: String(index + 1) })))
    }
    this.props.updatePairs([..._pairs, ..._rightPorts])
    this.setState({
      portList: [..._portList, ...rightPorts]
    })
  }

  nodeSelectRender = ({ portName, port, type, currentItem, isDie = false }) => {
    const { searchValue, selectFile = {}, maxHeight } = this.state;
    const { selectFileList } = this.props;
    // const currentInfo = modelInfoListIndex > -1 ? modelInfoList[modelInfoListIndex] : null;
    // const _pinList = editType ? currentInfo && currentInfo.modelPinList ? currentInfo.modelPinList : [] : pinList;
    const nodeList = this.getDisplayPortList({ currentItem, searchValue, selectFile });
    const { libraryId, subckt, fileName, modelKey } = selectFile;
    // const displayPin = currentItem[`pinNodeDisplay`] ? currentItem[`pinNodeDisplay`] : pin;
    return (
      <div className='nodes-content' style={{ maxHeight, maxWidth: 400 }}>
        <div className='nodes-content-header'>
          <span className='nodes-content-header-span'> {portName ? portName : `Port ${port}`}</span>
        </div>
        <div className='node-content-close' onClick={() => this.closeNodesSelection()}>
          <CloseOutlined className='node-content-close-icon' />
        </div>
        <div className="node-list-body-with-search">
          <div className="node-list-body-search-wrapper">
            <Select
              placeholder={`Select File/Subckt`}
              className='nodes-list-file-select'
              labelInValue
              value={{
                key: libraryId ? subckt ? `${libraryId}::${modelKey}::${subckt}` : `${libraryId}::${modelKey}` : "",
                label: subckt ? `${fileName}::${subckt}` : fileName || ""
              }}
              popupClassName='nodes-list-file-dropdown'
              popupMatchSelectWidth={false}
              onChange={option => option && this.selectNodesFile({ label: option.label, key: option.value })}
              options={selectFileList.map(item => ({
                value: item.subckt ? `${item.libraryId}::${item.modelKey}::${item.subckt}` : `${item.libraryId}::${item.modelKey}`,
                label: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                title: item.subckt ? `${item.fileName}::${item.subckt}` : item.fileName || "",
                className: "spice-nodes-content-file"
              }))}
            />
            <Input
              placeholder={`Search`}
              allowClear
              suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : null}
              value={searchValue}
              onChange={(e) => this.searchNode(e)}
            />
            <ul className='node-list-ul' style={{ maxHeight: maxHeight - 100 }}>
              {nodeList.map(item =>
                <li
                  key={item.node}
                  title={item.node}
                  className={item.currentSelect ? 'current-pin-selected-node-li' : (item.select ? 'node-li-selected' : '')}
                  onClick={() => !item.select ? this.selectPinNode({ node: item.node, selectFile, type, currentItem, isDie }) : null}
                >
                  {item.note || item.node}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  pinLine = () => {
    return <div className='spice-pin-line'></div>
  }

  pinCircle = () => {
    return <div className='spice-pin-circle'></div>
  }

  getPCBPinDisplay = ({ item, editNode, isLeft }) => {
    const [editDesignId, editPowerNet, editPort] = strDelimited(editNode, '-')
    const { port = '', designId = '', portName = '', nodes = [], powerNet = '' } = item || {}
    const key = `${designId}-${port}`
    const input = nodes && nodes.length ? nodes.length > 1 ? `${nodes[0]}, +${nodes.length - 1}` : nodes[0] : ""
    const suffix = nodes && nodes.length && nodes.length > 1 ? `+${nodes.length - 1}` : ""
    const pinNode = () => {
      return <div className={isLeft ? 'spice-pin-die-value-box' : 'spice-pin-value-box'}>
        {editNode && editDesignId === designId && editPowerNet === powerNet && editPort === port ? <Popover
          classNames={{ root: 'spice-node-select-Popover' }}
          content={this.nodeSelectRender({
            portName: portName,
            port: port,
            type: isLeft ? "leftPort" : "rightPort",
            currentItem: item
          })}
          title=""
          trigger="click"
          open={true}
          placement={"top"}
        >
          <Input
            className='spice-pin-input'
            placeholder={'Node'}
            value={input}
            id={port}
            onClick={(e) => this.openSelectNode({
              e,
              port: port,
              value: nodes,
              type: isLeft ? "leftPort" : "rightPort",
              currentItem: item,
              item: item,
            })}
          />
        </Popover> :
          nodes && nodes.length ?
            <Tooltip
              classNames={{ root: "aurora-tooltip" }}
              onClick={(e) => this.stopPropagation(e)}
              title={<Fragment>{item && item.fileName && <div>FileName:{item.fileName}</div>}<div>Port:{item.nodes.join(', ')}</div></Fragment>}>
              <div className='spice-pin-input' id={port} title={item.nodes.join(', ')}
                onClick={(e) => this.openSelectNode({
                  e,
                  port: port,
                  value: nodes,
                  type: isLeft ? "leftPort" : "rightPort",
                  currentItem: item,
                  item: item,
                })}
              >
                <span style={suffix ? { maxWidth: 55 } : {}}>{nodes[0]}</span>
                {suffix ? <span style={{ width: 25 }}>, {suffix}</span> : null}
                <CloseCircleFilled
                  className='spice-pin-node-delete-icon'
                  onClick={(e) => { this.deleteSelectNode(e, "leftPort", item) }}
                />
              </div>
            </Tooltip>
            :
            // !item.displayType && 
            <Input
              className='spice-pin-input'
              placeholder={'Node'}
              value={input}
              id={port}
              onClick={(e) => this.openSelectNode({
                e,
                port: port,
                value: nodes,
                type: "leftPort",
                currentItem: item,
                item: item,
              })}
            />}
      </div>
    }

    const pinPort = () => {
      return <Fragment>
        <div className={isLeft ? 'spice-pin-die-box' : 'spice-pin-box'}
          title={portName ? portName : `Port ${port}`}
        >
          {portName ? portName : `Port ${port}`}
        </div>
      </Fragment>
    }

    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 204 }}>
        {port ?
          isLeft ? <Fragment>
            {pinNode()}
            {pinPort()}
            {this.pinLine()}
            {this.pinCircle()}
          </Fragment> : <Fragment>
            {this.pinCircle()}
            {this.pinLine()}
            {pinPort()}
            {pinNode()}
          </Fragment> : null}
      </div>
    )
  }

  getDiePinDisplay = ({ item, isLeft, net }) => {
    const { port = '', designId = '', portName = '' } = item || {}
    const key = `${designId}-${port}-${net}`;
    const pinPort = () => {
      return <Fragment>
        <div
          className={isLeft ? 'spice-pin-die-box' : 'spice-pin-box'}
          title={portName ? portName : `Port ${port}`}
          style={{ width: 160 }}
        >
          {portName ? portName : `Port ${port}`}
        </div>
      </Fragment>
    }
    return (
      <div key={key} className='spice-total-pin-box' style={{ width: 204 }}>
        {port ?
          isLeft ? <Fragment>
            {pinPort()}
            {this.pinLine()}
            {this.pinCircle()}
          </Fragment> : <Fragment>
            {this.pinCircle()}
            {this.pinLine()}
            {pinPort()}
          </Fragment> : null}
      </div >
    );
  }

  titleContent = () => {
    const { overviewReverse } = this.props;
    const leftTitle = overviewReverse ? 'PCB' : 'Die';
    const rightTitle = overviewReverse ? 'Die' : 'PCB';
    return <div className="spice-pin-connect-node-title" style={{ paddingLeft: 20 }}>
      <span className='spice-pin-left-title cascade-spice-pin-left-title'>{leftTitle}</span>
      <span className='spice-pin-right-title cascade-spice-pin-right-title'>{rightTitle}</span>
      <DeleteOutlined
        title="Clean Ports"
        onClick={() => this.cleanPort()} />
    </div>
  }

  dieRender = (diePorts, editNode, isLeft, net) => {
    const dieCurrentItem = this.getDieNodes(diePorts, net)
    return <div className={`cascade-package-modle-netlist-die ${diePorts.length ? '' : 'empty-die'}`}>
      {diePorts.length ? diePorts.map(item => this.getDiePinDisplay({ item, editNode, isLeft, net })) : this.getDiePinDisplay({ item: {}, editNode, isLeft, net })}
      <span>{diePorts.length ? '' : 'Select die nodes'}</span>
      {
        editNode === `${IMPEDANCE_PACKAGE_FILE}-${net}-die_${net}` ? <Popover
          classNames={{ root: 'spice-node-select-Popover' }}
          content={this.nodeSelectRender({
            portName: `die_${net}`,
            port: `die_${net}`,
            type: isLeft ? "leftPort" : "rightPort",
            currentItem: dieCurrentItem,
            isDie: true
          })}
          title=""
          trigger="click"
          open={true}
          placement={"top"}
        >
          <div className='selected-die'></div>
        </Popover> :
          <div
            className='select-die'
            onClick={(e) => this.openSelectNode({
              e,
              port: dieCurrentItem.port,
              value: dieCurrentItem.nodes,
              type: isLeft ? "leftPort" : "rightPort",
              currentItem: dieCurrentItem,
              item: dieCurrentItem,
            })} ></div>
      }
    </div>
  }

  render() {
    const { editNode, portList } = this.state;
    const { overviewReverse } = this.props;
    let className = "spice-pin-connect-node-item";

    const signalSelectDisableClassName = '';
    const nets = [...new Set(portList.map(port => port.powerNet))];
    return (
      <Fragment>
        <div className='spice-netlist-model-content'>

          <div className='spice-connect-content'>
            <ul className='spice-pin-list-ul'>
              {this.titleContent()}
              {nets.map((net, index) => {
                const pcbPorts = portList.filter(item => item.powerNet === net && item.type === 'left');
                const diePorts = portList.filter(item => item.powerNet === net && item.type === 'right');
                const maxLength = Math.max(pcbPorts.length, diePorts.length)
                return <div className={`${className}`} key={index} style={{ height: 32 * maxLength + 30, paddingRight: 10 }}>
                  <div className='spice-pin-list-li-left'>
                    {
                      overviewReverse ? pcbPorts.map(item => this.getPCBPinDisplay({ item, editNode, isLeft: true }))
                        : this.dieRender(diePorts, editNode, true, net)
                    }
                    { }
                  </div>
                  {/* net box */}
                  <div
                    className={index === 0 ? `spice-box spice-box-top ${signalSelectDisableClassName}` : (index === (portList.length - 1) ? `spice-box spice-box-bottom ${signalSelectDisableClassName}` : `spice-box ${signalSelectDisableClassName}`)}
                  >
                    <span className='spice-box-net-text'>{net}</span>
                  </div>
                  <div className='spice-pin-list-li-right'>
                    {
                      overviewReverse ? this.dieRender(diePorts, editNode, false, net)
                        : pcbPorts.map(item => this.getPCBPinDisplay({ item, editNode, isLeft: false }))
                    }
                  </div>
                </div>
              })}
            </ul>
          </div>
        </div>
      </Fragment >
    );
  }
}

export default pkgModel;